/**
 * @generated SignedSource<<db333a2b44fa33e35e4c65016f7b00a6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getHasEnoughSimilarSoldItems_viewer$data = {
  readonly similarSoldItemsResults?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "getHasEnoughSimilarSoldItems_viewer";
};
export type getHasEnoughSimilarSoldItems_viewer$key = {
  readonly " $data"?: getHasEnoughSimilarSoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"getHasEnoughSimilarSoldItems_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getHasEnoughSimilarSoldItems_viewer"
};

(node as any).hash = "2fdcbc6320560444a0e55cd6928039b0";

export default node;
